<template>
  <v-layout row justify-center>
    <Generic_Translations
      v-if='openAccountTranslations'
      :columns="accountColumns"
      :translations="accountTranslations"
      @closeTranslations="closeAccountTranslations"
      @saveTranslations="saveTranslations"
    ></Generic_Translations>
    <v-flex xs8 class="pl-2 pr-2">
      <v-layout
        align-start
        justify-start
        class="mb-4">
        <v-icon color="primary" style="font-size: 50px;">settings</v-icon>
        <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{$translate('PREFERENCES')}}</h2>
        <v-layout row justify-end>
          <v-btn fab
                 small
                 color="primary">
            <v-icon medium
                    @click="getTranslations">language</v-icon>
          </v-btn>
        </v-layout>
      </v-layout>
      <!-- <v-divider class="mx-2" inset vertical></v-divider> -->

      <v-spacer></v-spacer>
      <div v-for="(p, index) in _customerPreferencesObjects" :key="index">
        <!-- {{p}} -->
        <v-flex xs4 v-if="p.Type=='color'">
          <v-menu
            ref="menu3"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
          >
            <v-btn slot="activator" :color="p.Value">{{p.Key}} - {{p.Value}}</v-btn>
            <sketch-picker :value="p.Value" @input="e => p.Value = e.hex" />
          </v-menu>
        </v-flex>
        <v-flex v-else-if="p.Type=='number'">
          <h4 class="mt-4">{{p.Key}}</h4>
          <v-text-field
            type="number"
            auto-grow
            class="mb-4"
            v-model="p.Value"
            outline
            hide-details
            item-text="label"
            item-value="value"
            ref="eventForm"
          />
        </v-flex>
        <v-flex v-else-if="p.Type=='audio'">
          <audio-loader :properties="p.Value" v-on:selectAudio1Element="setAudioElement"></audio-loader>
        </v-flex>
        <v-flex v-else-if="p.Type=='image'">
          <h4 class="mt-4">{{p.Key}}</h4>
          <image-loader
            class="pb-2"
            :properties="{pictureUrl: p.Value, pictureName: p.Key, signalName: p.Key, deletable: false}"
            @[p.Key]="setImageElement"
          ></image-loader>
        </v-flex>
        <v-flex v-else-if="p.Type=='string'">
          <h4 class="mt-4">{{p.Key}}</h4>
          <v-text-field
            auto-grow
            class="mb-4"
            v-model="p.Value"
            outline
            hide-details
            item-text="label"
            item-value="value"
            ref="eventForm"
          />
        </v-flex>
      </div>

      <v-layout align-end justify-end row offset-xs0 offset-lg2 mb-3>
        <v-card-actions>
          <v-tooltip bottom>
            <v-btn
              round
              :disabled="disableSave"
              :loading="disableSave"
              slot="activator"
              color="primary"
              class="v-btn-5 dialogButton text-capitalize"
              @click="savePreferences"
            >{{$translate('SAVE')}}</v-btn>
            <span>{{$translate('SAVE')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import ImageLoader from "@/components/media/ImageLoader";
import AudioLoader from "@/components/media/AudioLoader";
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import { Sketch } from "vue-color";
import _ from "lodash";
import { mapGetters } from "vuex";
import BaseComponent from "../base/BaseComponent.vue";
import Generic_Translations from "../Generic_Translations";

export default {
  extends: BaseComponent,
  name: "AccountPreferences",
  components: {
    Generic_Translations,
    AudioLoader,
    ImageLoader,
    "sketch-picker": Sketch,
  },
  computed: {
    ...mapGetters({
      _customerPreferencesObjects: "getCustomerPreferencesObjects",
      tmpPartnerAdmin: "auth/tmpPartnerAdmin"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Role" : "Edit Role";
    }
  },
  watch: {
    output: function(newV, oldV) {},

    tmpPartnerAdmin: function(newV, oldV) {
      if (newV !== oldV && newV === true) {
        window.EventBus.fire("getPartnerPreferences");
      }
    }
  },
  data() {
    return {
      selectedAccount: {},
      accountTranslations: {},
      accountColumns: [],
      openAccountTranslations: false,

      disableSave: false,
      users: [],
      part: 1,
      output: "",
      editedItem: {},
      editedIndex: -1,
      dialog: false,
      roles: [],
      // userGroupData: [],
      disableButton: true,
      colors: "",

      defaultItem: {
        description: "",
        type: "Specific"
      },
      headers: [
        {
          text: "Role name",
          align: "left",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
  },
  methods: {
    closeAccountTranslations() {
      this.selectedAccount = {};
      this.openAccountTranslations = false;
    },
    getTranslations() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getTranslations on - Account_Preferences.vue - was successful', response);
          this.accountTranslations = {};
          this.accountColumns = [];
          this.selectedAccount = {};
          this.accountTranslations = response.data.Translations;
          this.accountColumns = response.data.ColumnNames;
          this.openAccountTranslations = true;
        },
        (error) => {
          console.log('The generic call getTranslations on - Account_Preferences.vue - was not successful', error);
        },
        'getTranslations',
        this.currentAccountId,
        payload,
      );
    },
    saveTranslations(translationData) {
      let payload = {};
      payload.Translations = translationData;
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for saveTranslations on - Account_Preferences.vue - was successful",
            response
          );
          this.openAccountTranslations = false;
          this.selectedAccount = {};
        },
        (error) => {
          console.log(
            "The call for saveTranslations on - Account_Preferences.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveTranslations',
        this.currentAccountId,
        payload,
      );
    },
    cancelAction() {},

    savePreferences() {
      if (this.$store.getters["auth/userLevel"] < 7) {
        this.savePartnerPreferences();
      } else {
        this.saveAccountPreferences();
      }
    },

    savePartnerPreferences() {
      this.disableSave = true;
      let payload = {
        FunctionId: "AccountFunctionLibrary::savePartnerPreferences",
        PartnerId: this.$store.getters["auth/partnerId"],
        Preferences: {}
      };
      this._customerPreferencesObjects.forEach((e, index) => {
        payload.Preferences[index] = e;
      });

      dssRequest.doRequest(
        response => {
          console.log("The call for savePartnerPreferences was successful", response);
          window.EventBus.fire(
            "activateSnackBar",
            this.$translate("PARTNER_PREFERENCES_SAVED_CORRECTLY")
          );
          this.disableSave = false;
          window.EventBus.fire("getPartnerPreferences");
        },
        error => {
          console.log("The call for savePartnerPreferences was not succesfull", error);
          this.disableSave = false;
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },

    saveAccountPreferences() {
      this.disableSave = true;
      let payload = {
        Preferences: {}
      };
      this._customerPreferencesObjects.forEach((e, index) => {
        payload.Preferences[index] = e;
      });

      dssRequest.doRequest(
        response => {
          console.log("The call for updateAccount was successful", response);
          window.EventBus.fire(
            "activateSnackBar",
            this.$translate("ACCOUNT_PREFERENCES_SAVED_CORRECTLY")
          );
          this.disableSave = false;
          window.EventBus.fire("getAccountInfo", {});
        },
        error => {
          console.log("The call for updateAccount was not succesfull", error);
          this.disableSave = false;
        },
        "updateAccount",
        this.currentAccountId,
        payload
      );
    },
    setImageElement(input) {
      this._customerPreferencesObjects.forEach(e => {
        if (e.Key == input.signalName) e.Value = input.url;
      });
    },
    setAudioElement() {},
    manageDataForComponent(data) {

      // this.tagData = data.tags;
      this.disableButton = false;
      if (_.isEmpty(data)) this.createEmptyUserGroup();
    }
  }
};
</script>

<style lang="scss" scoped>
.usergroups {
  height: 85vh;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
